import { render, staticRenderFns } from "./NowPlaying.vue?vue&type=template&id=7fb44639&scoped=true&"
import script from "./NowPlaying.vue?vue&type=script&lang=js&"
export * from "./NowPlaying.vue?vue&type=script&lang=js&"
import style0 from "@/styles/components/now-playing.scss?vue&type=style&index=0&id=7fb44639&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb44639",
  null
  
)

export default component.exports